import { Block } from '@contentful/rich-text-types'
import React from 'react'
import cn from 'classnames'
import styles from './rich-text.module.scss'

interface OlListProps extends Block {
  children?: React.ReactNode
}

export const OlList: React.FC<OlListProps> = (props) => {
  return <ol className={cn(styles.list, styles.olList)}>{props.children}</ol>
}
